export const STRIPE_DEBIT_AGREEMENT_START_DATE = '2023-11-02T00:00:00.000Z'

export const STRIPE_DEBIT_AGREEMENT_START_DATETIME = new Date(STRIPE_DEBIT_AGREEMENT_START_DATE).getTime()
